export const SET_APP_ENVIRONMENT = 'SET_APP_ENVIRONMENT' as const;

type SetApplicationEnvTargetAction = {
  type: typeof SET_APP_ENVIRONMENT;
  payload: string;
};

export const setApplicationEnvTarget = (envTarget: string): SetApplicationEnvTargetAction => ({
  type: SET_APP_ENVIRONMENT,
  payload: envTarget,
});

export type ApplicationEnvActions = SetApplicationEnvTargetAction;
